import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "./CustomDatePicker.css";

dayjs.extend(customParseFormat);

const CustomDatePicker = ({
  label,
  value,
  onChange,
  className = "ba-input",
  disabled = false,
  minDate = null,
  maxDate = null,
  error = false,
  helperText = "",
  fullWidth = true,
  placeholder = "Select date",
  slotProps: externalSlotProps,
  ...otherProps
}) => {
  // Helper function to convert value to dayjs
  const getDayjsValue = (val) => {
    if (!val) return null;
    if (dayjs.isDayjs(val)) return val;
    if (typeof val === "string" || val instanceof Date) {
      const parsed = dayjs(val);
      return parsed.isValid() ? parsed : null;
    }
    return null;
  };

  // Helper function to convert minDate/maxDate to dayjs
  const getDayjsDate = (date) => {
    if (!date) return null;
    if (dayjs.isDayjs(date)) return date;
    if (typeof date === "string" || date instanceof Date) {
      const parsed = dayjs(date);
      return parsed.isValid() ? parsed : null;
    }
    return null;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={getDayjsValue(value)}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        disabled={disabled}
        minDate={getDayjsDate(minDate)}
        maxDate={getDayjsDate(maxDate)}
        format="DD/MM/YYYY"
        slotProps={{
          ...externalSlotProps,
          textField: {
            fullWidth: fullWidth,
            error: error,
            helperText: helperText,
            placeholder: placeholder,
            ...externalSlotProps?.textField,
            className: [className, "ashtang-date-field", externalSlotProps?.textField?.className]
              .filter(Boolean)
              .join(" "),
          },
          popper: {
            ...externalSlotProps?.popper,
            className: ["ashtang-date-popper", externalSlotProps?.popper?.className]
              .filter(Boolean)
              .join(" "),
            sx: {
              zIndex: 9999,
              ...externalSlotProps?.popper?.sx,
            },
          },
          desktopPaper: {
            ...externalSlotProps?.desktopPaper,
            className: ["ashtang-date-paper", externalSlotProps?.desktopPaper?.className]
              .filter(Boolean)
              .join(" "),
          },
          mobilePaper: {
            ...externalSlotProps?.mobilePaper,
            className: ["ashtang-date-paper", externalSlotProps?.mobilePaper?.className]
              .filter(Boolean)
              .join(" "),
          },
        }}
        {...otherProps}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;

